// these functions can only be used after importing
// ref: https://gist.github.com/vielhuber/afcb99fdf23febffe0199649e19642cb
// returns only keywords from an array
function onlyKeywords(arr) {
    var keywords = []
    for (let index = 0; index < arr.length; index++) {
        let row = {
            keyword: arr[index],
        }
        keywords.push(row)
    }
    return keywords
}
export { onlyKeywords };